function Renderer (width, height) {
  this.width = width
  this.height = height
  this.domElement = null
}

Renderer.prototype._init = function () {}
Renderer.prototype.drawImage = function () {}

module.exports = Renderer



//////////////////
// WEBPACK FOOTER
// ./~/_image-sprite@1.0.0@image-sprite/src/renderer.js
// module id = 53
// module chunks = 0